import { useTranslation } from 'next-i18next';
import { trackEvent } from '@zep/logger/tracking';
import { useLocale } from '@/hooks';
import { ExportIcon } from '@/icons';
import { Button } from '@/ui_v3';
import { getBoardGuideUrl, SECTION_PADDING } from '../constants';
const FAQ_IDS = ['whatIsBoard', 'joinWithoutLogin', 'boardLimit', 'fileSize'] as const;
export function BoardLandingFaq() {
  const {
    t
  } = useTranslation(['boardLanding']);
  return <section aria-labelledby="board-landing-faq-heading" className={`flex flex-col items-center gap-2xl ${SECTION_PADDING}`} data-sentry-component="BoardLandingFaq" data-sentry-source-file="BoardLandingFaq.tsx">
      <h2 id="board-landing-faq-heading" className="text-center text-display-sm-extrabold text-default">
        {t('boardLanding:faq.title')}
      </h2>

      {/* 답변이 항상 보이는 정적 Q/A 라서 아코디언이 아니라 정의 목록이다. */}
      <dl className="flex w-full max-w-[800px] flex-col gap-2xs">
        {FAQ_IDS.map(id => <div key={id} data-testid="board-landing-faq-item" className="flex flex-col gap-sm rounded-md bg-neutral px-xl py-lg">
            <dt className="flex gap-xs text-heading-sm-bold text-default">
              <span aria-hidden="true" className="text-strong">
                Q
              </span>
              {t(`boardLanding:faq.${id}.question`)}
            </dt>
            {/* Q 글리프 + gap 만큼 들여써서 답변이 질문 텍스트와 같은 선에서 시작한다. */}
            <dd className="pl-[26px] text-body-lg-medium text-neutral">
              {t(`boardLanding:faq.${id}.answer`)}
            </dd>
          </div>)}
      </dl>

      <GuideButton data-sentry-element="GuideButton" data-sentry-source-file="BoardLandingFaq.tsx" />
    </section>;
}
function GuideButton() {
  const {
    locale
  } = useLocale();
  const {
    t
  } = useTranslation(['boardLanding']);
  return <Button variant="outlined" intent="alternative" size="lg" rounded="default" asChild data-sentry-element="Button" data-sentry-component="GuideButton" data-sentry-source-file="BoardLandingFaq.tsx">
      <a href={getBoardGuideUrl(locale)} target="_blank" rel="noopener noreferrer" data-testid="board-landing-guide" onClick={() => trackEvent('board_landing_guide_click', {})}>
        {t('boardLanding:faq.guideButton')}
        <ExportIcon size="sm" data-sentry-element="ExportIcon" data-sentry-source-file="BoardLandingFaq.tsx" />
      </a>
    </Button>;
}